import React from "react";
import {
  MDSButton,
  MDSButtonGroup,
  MDSButtonVariant,
  MDSDialog,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSPopover,
  MDSText,
  MDSTextVariant,
} from "@/mds";
import { pluralize } from "@/modules/pluralize";

interface CloseAllTabsModalProps {
  isOpen: boolean;
  count: number;
  onCancel: () => void;
  onConfirm: () => void;
  triggerRef: React.RefObject<Element>;
}

export const CloseAllTabsModal: React.FC<CloseAllTabsModalProps> = ({
  isOpen,
  count,
  onCancel,
  onConfirm,
  triggerRef,
}) => {
  return (
    <MDSPopover styling={false} triggerRef={triggerRef} isOpen={isOpen} isNonModal>
      <MDSDialog isOpen={isOpen} handleClose={onCancel} fluidWidth isDismissable={false}>
        <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
          <MDSText variant={MDSTextVariant.ParagraphS}>
            Are you sure you want to close {count} {pluralize(count, "tab", "tabs")}?
          </MDSText>
        </MDSDialogTextContent>
        <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
          <MDSButton onClick={onCancel}>Cancel</MDSButton>
          <MDSButton variant={MDSButtonVariant.DangerFilled} onClick={onConfirm}>
            Close
          </MDSButton>
        </MDSButtonGroup>
      </MDSDialog>
    </MDSPopover>
  );
};
